import { render, staticRenderFns } from "./Conclusion.vue?vue&type=template&id=939716c4&scoped=true"
import script from "./Conclusion.vue?vue&type=script&setup=true&lang=ts"
export * from "./Conclusion.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Conclusion.vue?vue&type=style&index=0&id=939716c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "939716c4",
  null
  
)

export default component.exports